<template>
    <card-sections
        :title="Lang.get('employerdashboard::pages/settings/two-factor-authentication.title')"
        :subtitle="Lang.get('employerdashboard::pages/settings/two-factor-authentication.subtitle')"
        tabName="two-factor-authentication"
        :hideMsg="true"
    >
        <p class="font-poppins font-weight-light color-dark-blue">
            {{ Lang.get('employerdashboard::pages/settings/two-factor-authentication.recovery-codes.heading') }}
        </p>
        <div class="row">
            <div class="col-12 col-md-6 mb-4">
                <div class="samp-wrapper p-2 border-radius-8">
                    <samp>
                        <template v-for="(code, idx) in recoveryCodes">
                            {{ code.code }}<br v-if="idx % 2 === 1">
                        </template>
                    </samp>
                    <button
                        @click="copyCodesToClipboard"
                        class="btn btn-black-outlined font-poppins border-radius-19 px-4 mt-2">
                        <img src="/img/employer-dashboard/icon-copy-paste.svg" class="mr-1 mr-md-0">&nbsp;
                        {{ Lang.get('employerdashboard::pages/settings/two-factor-authentication.recovery-codes.copy-button') }}
                    </button>
                </div>
            </div>
        </div>
        <p class="font-poppins font-weight-light color-dark-blue"
           v-html="Lang.get('employerdashboard::pages/settings/two-factor-authentication.recovery-codes.warning')"
        ></p>
    </card-sections>
</template>

<script>
import CardSections from "@/Pages/Settings/Shared/CardSections";
import TextInput from "@/Shared/TextInput";

export default {
    components: {
        CardSections,
        TextInput,
    },
    props: {
        recoveryCodes: Array,
    },
    methods: {
        copyCodesToClipboard() {
            navigator.clipboard.writeText(this.recoveryCodes.map(code => code.code).join('\n'));
        },
    },
}
</script>
